import { EFeatureTypes } from 'enums/EFeatureTypes';
import { setCookie } from 'utils/Global';

const PRODUCT_SWITCH_KEY = 'rm_product_switch';
const PRODUCT_SWITCH_PENDING_KEY = 'rm_product_switch_pending';
export const DEFAULT_PRODUCT_SWITCH_REDIRECT = '/project';

export function markProductSwitchPending(): void {
  sessionStorage.setItem(PRODUCT_SWITCH_PENDING_KEY, 'true');
}

export function consumeProductSwitchPending(): boolean {
  const pending = sessionStorage.getItem(PRODUCT_SWITCH_PENDING_KEY) === 'true';
  if (pending) {
    sessionStorage.removeItem(PRODUCT_SWITCH_PENDING_KEY);
  }
  return pending;
}

export function broadcastProductSwitch(): void {
  localStorage.setItem(PRODUCT_SWITCH_KEY, String(Date.now()));
}

export function performProductSwitch(
  feature: EFeatureTypes,
  redirectTo = DEFAULT_PRODUCT_SWITCH_REDIRECT,
): void {
  setCookie(EFeatureTypes.SelectedFeature, feature);
  broadcastProductSwitch();
  window.location.href = redirectTo;
}

export { PRODUCT_SWITCH_KEY };
